module.exports = __webpack_public_path__ + "static/media/icon_4g_sim.28d3a83b.svg";